import { get } from 'lodash';
import isMobileOrTabletBreakpoint from '@zocdoc-frontend-common/utils-deviceutils/isMobileOrTabletBreakpoint';
import logToDataDog from '../../../../config/logToDataDog';

/**
 * @description determines whether the post-booking survey should be displayed
 * @param {int} directoryId
 * @param {boolean} isReschedule
 * @param {boolean} isVaccineApt
 * @param {object|null} surveyQuestionsData
 * @returns {boolean}
 */
export const getShouldShowSurvey = ({
    directoryId,
    isReschedule,
    isVaccineApt,
    surveyQuestionsData,
}) => {
    const platform = isMobileOrTabletBreakpoint() ? 'MobileWeb' : 'Desktop';

    if (isReschedule) {
        logToDataDog({
            name: 'booking-web-app.shouldNotShowSurvey',
            type: 'increment',
            value: 1,
            tags: ['noSurveyReason:isReschedule', `platform:${platform}`],
        });
        return false;
    }

    if (isVaccineApt) {
        logToDataDog({
            name: 'booking-web-app.shouldNotShowSurvey',
            type: 'increment',
            value: 1,
            tags: [
                'noSurveyReason:isVaccineAppointment',
                `platform:${platform}`,
            ],
        });
        return false;
    }

    if (directoryId === 0) {
        logToDataDog({
            name: 'booking-web-app.shouldNotShowSurvey',
            type: 'increment',
            value: 1,
            tags: ['directoryIdIs0', `platform:${platform}`],
        });
        return false;
    }

    // dont render survey for whitelabels
    if (directoryId !== -1 && directoryId !== null) {
        logToDataDog({
            name: 'booking-web-app.shouldNotShowSurvey',
            type: 'increment',
            value: 1,
            tags: ['noSurveyReason:isWhiteLabel', `platform:${platform}`],
        });
        return false;
    }

    if (surveyQuestionsData == null) {
        logToDataDog({
            name: 'booking-web-app.shouldNotShowSurvey',
            type: 'increment',
            value: 1,
            tags: [
                'noSurveyReason:surveyQuestionsDataInDefaultState',
                `platform:${platform}`,
            ],
        });
        return false;
    }

    if (!Object.keys(surveyQuestionsData).length) {
        logToDataDog({
            name: 'booking-web-app.shouldNotShowSurvey',
            type: 'increment',
            value: 1,
            tags: [
                'noSurveyReason:failedToFetchQuestions',
                `platform:${platform}`,
            ],
        });
        return false;
    }

    if (!surveyQuestionsData.questions?.length) {
        logToDataDog({
            name: 'booking-web-app.shouldNotShowSurvey',
            type: 'increment',
            value: 1,
            tags: ['noSurveyReason:missingQuestions', `platform:${platform}`],
        });
        return false;
    }

    if (
        !surveyQuestionsData.questions[0].possible_answers ||
        !surveyQuestionsData.questions[0].possible_answers[0] ||
        surveyQuestionsData.questions[0].possible_answers[0] === {}
    ) {
        logToDataDog({
            name: 'booking-web-app.shouldNotShowSurvey',
            type: 'increment',
            value: 1,
            tags: ['noSurveyReason:missingPossibleAnswers'],
        });
        return false;
    }

    const questionTitleText = get(
        surveyQuestionsData,
        'questions[0].display_text'
    );

    if (!questionTitleText) {
        logToDataDog({
            name: 'booking-web-app.shouldNotShowSurvey',
            type: 'increment',
            value: 1,
            tags: ['noSurveyReason:missingTitleText'],
        });
        return false;
    }
    return true;
};
